import flowRuleApi from '@/api/config/flowRuleApi'
import { queryKeys } from '@/constant/common'
import { UpdateFlowRule } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'

async function updateFlowRule(payload: UpdateFlowRule): Promise<void> {
  await flowRuleApi.update(payload)
}

function useUpdateFlowRule() {
  const queryClient = useQueryClient()

  return useMutation((payload: UpdateFlowRule) => updateFlowRule(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.flowRule])
      toast.success('Edit Flow Rule Success')
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useUpdateFlowRule
